import { useState } from 'react';
import { capitalize } from 'lodash-es';

import Refresh from '@/icons/light/refresh-cw.svg';
import { Button, ModalGallery } from '@/atoms';
import { ButtonSize, ButtonVariant } from '@/atoms/button/types';

import { gtmPush } from '@/utils';

import type { FunctionComponent } from 'react';
import type { TypeModalView360Props } from './types';

export const ModalView360: FunctionComponent<TypeModalView360Props> = ({
  src,
  flat,
  type,
}: TypeModalView360Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {type === 'button' && (
        <Button
          variant={ButtonVariant.SECONDARY}
          size={ButtonSize.SMALL}
          className="max-w-max"
          onClick={() => {
            setIsOpen(true);
            gtmPush({
              event: 'explore_360_view',
              item_id: flat?.codigoUnidadAlquiler,
              item_name: flat?.nombreUE,
              item_type: capitalize(flat?.ventaAlquiler ?? ''),
            });
          }}
        >
          Explorar en 360º
        </Button>
      )}

      {type === 'link' && (
        <button
          className="flex items-center gap-2 text-primary-500"
          onClick={() => {
            setIsOpen(true);
            gtmPush({
              event: 'explore_360_view',
              item_id: flat?.codigoUnidadAlquiler,
              item_name: flat?.nombreUE,
              item_type: capitalize(flat?.ventaAlquiler ?? ''),
            });
          }}
        >
          Explorar en 360º
          <Refresh width={24} height={24} className="shrink-0" />
        </button>
      )}

      <ModalGallery
        closeModal={() => setIsOpen(false)}
        isOpen={isOpen}
        unmount
        className="u-wrapper scrollbar-hide h-full overflow-y-auto bg-neutrals-0 lg:rounded-lg"
      >
        <iframe src={src} className="h-full w-full pb-4 md:min-h-[600px]" />
      </ModalGallery>
    </>
  );
};

ModalView360.displayName = 'ModalView360';
